<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <modal-form modal-id="add-user-role" animation="fadeInRight">
      <div slot="title">Add New User Role</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-3">Name</div>
            <div class="col-lg-9">
              <input type="text" name="" class="form-control" v-model="addUserRole['name']">
            </div>
          </div>
          <div class="row m-t-lg">
            <div v-for="(permission, index) in addUserRole['permissions']" :key="index">
            <div class="col-lg-3"><span v-show="index === 0">Permisions</span></div>
            <div class="col-lg-8">
              <input type="text" v-model="addUserRole['permissions'][index]" :id="'permission-' + index" class="col-lg-8 form-control" @keydown.enter="addNewPermission">
            </div>
              <div class="col-lg-1 p-h-xs"><a v-show="addUserRole['permissions'].length == index + 1" @click="addNewPermission">Add</a></div>
          </div>
          </div>
          <div class="row m-t-md">
            <div class="col-lg-12">
              <button class="btn btn-sm btn-primary" @click="saveUserRole">Save</button>
            </div>
          </div>
        </div>
      </div>
    </modal-form>
    <div class="ibox row">
      <div class="ibox-title">
        <h5>User Roles</h5>
        <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-user-role">Add user role</button>
      </div>
      <div class="ibox-content col-lg-12">
        <div class="col-lg-12 m-t-sm"></div>
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>
import List from './Roles/List'
import axios from 'axios'
import { USER_ROLE_LIST_SET } from '../../../store/mutation-types'
import EditText from '../../Helpers/Form/EditText'
import Modal from '../../Helpers/Modal/Form'
import { mapGetters } from 'vuex'

// Add User Defaults
const userRoleAddDefaults = {
  name: '',
  permissions: ['']
}

export default {
  data () {
    return {
      addUserRole: {...userRoleAddDefaults}
    }
  },
  computed: {
    ...mapGetters({
      userRoles: 'getUserRoles'
    })
  },
  mounted () {
    document.title = 'Admin Users :: PBN360 by Aphex Media'
    this.getUserRoles()
  },
  components: {
    list: List,
    modalForm: Modal,
    eTxt: EditText
  },
  methods: {
    addNewPermission () {
      if (this.addUserRole['permissions'][this.addUserRole['permissions'].length - 1].length === 0) return
      const index = this.addUserRole['permissions'].push('')
      this.$nextTick(() => {
        const newEl = document.getElementById('permission-' + (index - 1))
        newEl && newEl.focus()
      })
    },
    saveUserRole () {
      const addUserRole = {
        ...this.addUserRole,
        permissions:
          this.addUserRole.permissions
            .filter(p => typeof p === 'string' && p.length > 0)
            .map(p => p.trim())
      }
      if (!addUserRole.name || addUserRole.name.length < 1) {
        this.$toastr.error('Some data seems to be missing', 'Please try a bit harder')
        return
      }
      // Create new role
      axios.post('/user/role', addUserRole)
        .then(r => {
          $('#add-user-role').modal('hide')
          if (r.data && r.data.id) {
            this.$store.commit(USER_ROLE_LIST_SET, [...this.$store.state.userRoleList, r.data])
            this.$toastr.success('Role added successfully', 'Brilliant stuff lad')
          } else {
            this.$toastr.error('Something went wrong', 'Please try later')
          }
        })
        .catch(e => {
          const msg = e.response ? e.response.data.msg : 'Not so great is it...'
          this.$toastr.error(e, msg)
        })
      // Reset form to defaults
      Object.keys(userRoleAddDefaults).forEach(k => {
        this.$set(this.addUserRole, k, k === 'name' ? '' : [''])
      })
    },
    getUserRoles () {
      axios.get('/user/roles')
        .then(r => {
          this.$store.commit(USER_ROLE_LIST_SET, r.data)
        })
        .catch(e => {
          this.$toastr.error(e)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Roles.vue